import { http, setFormData } from '@/utils/http'
import { setUserData, getUserData } from '@/utils/auth'

import { USER_SET, USER_UNSET, USER_FETCH, USER_CREATE, USER_UPDATE } from '@/store/actions/user'
import permissionsData from '@/data/permissions'

const user = getUserData()

const state = {
  admins: [],
  agents: [],
  currentUser: user
}

const getters = {
  currentUser: state => state.currentUser,
  isAuthenticated: state => !!state.currentUser,
  userPermissions: (state, getters) => { // set user permissions
    let permissions = permissionsData.map(permission => {
      if (getters.isAuthenticated && permission.roles.includes(state.currentUser.role)) {
        return permission.id
      }
    })
    return permissions
  },
  userCan: (state, getters) => (permission) => {
    return getters.userPermissions.includes(permission)
  },
  admins: state => state.admins,
  agents: state => state.agents,
  agentsByParent: state => (parent) => {
    return state.agents.filter(agent => {
      return agent.parent_id === parent || agent.parent === parent
    })
  }
}

const mutations = {
  [USER_SET]: (state, payload) => {
    const currentUser = (state.currentUser === undefined || state.currentUser === null) ? {} : state.currentUser
    const user = Object.assign(currentUser, payload)
    state.currentUser = user
    setUserData(user)
  },
  [USER_UNSET]: state => {
    state.currentUser = null
  },
  [USER_FETCH]: (state, payload) => {
    if (payload.admins) {
      state.admins = [ ...payload.admins ]
    }
    else {
      state.agents = [ ...payload.agents ]
    }
  },
  [USER_UPDATE]: (state, payload) => {
    const model = payload.isAdmin ? 'admins' : 'agents'
    const updatedUsers = state[model].map(user => {
      return user._id === payload.user._id ? Object.assign(user, payload.user) : user
    })
    state[model] = updatedUsers
  }
}

const actions = {
  [USER_FETCH]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const model = payload.isAdmin ? 'administrator' : 'agent'
      http.get(model + '/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            const state = payload.isAdmin ? 'admins' : 'agents'
            commit(USER_FETCH, { [state]: response.data })
            resolve()
          }
          else {
            reject(response)
          }
        })
    })
  },
  [USER_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const model = payload.isAdmin ? 'administrator' : 'agent'
      // convert to form data first
      const params = setFormData(payload.user)
      http.post(model + '/signup', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [USER_UPDATE]: ({ commit }, payload) => { // { user, isAdmin, isCurrentUser }
    return new Promise((resolve, reject) => {
      const model = payload.isAdmin ? 'administrator' : 'agent'
      // convert to form data first
      const params = setFormData(payload.user)
      http.post(model + '/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            if (payload.isCurrentUser) {
              commit(USER_SET, payload.user)
            }
            else {
              commit(USER_UPDATE, payload)
            }
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
